import {
  Alert,
  AlertProps as MuiAlertProps,
  useMediaQuery,
  useTheme,
} from "@mui/material";

interface AlertProps {
  isAlert: {
    open: boolean;
    severity: MuiAlertProps["severity"];
    message: string;
  };
  setIsAlert: React.Dispatch<
    React.SetStateAction<{
      open: boolean;
      severity: MuiAlertProps["severity"];
      message: string;
    }>
  >;
}

const AlertComponent = ({ isAlert, setIsAlert }: AlertProps) => {
  // theme
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  setTimeout(() => {
    setIsAlert({
      open: false,
      severity: "" as MuiAlertProps["severity"],
      message: "",
    });
  }, 5000);

  return (
    <Alert
      severity={isAlert?.severity}
      sx={{
        position: "fixed",
        top: 36,
        left: 0,
        width: isMobile ? "80%" : "auto",
        maxWidth: "100%",
        marginLeft: isMobile ? "10%" : "50%",
        transform: isMobile ? "translateX(0)" : "translateX(-50%)",
        zIndex: 9999,
      }}
      onClose={() => setIsAlert({ ...isAlert, open: false })}
    >
      {isAlert?.message}
    </Alert>
  );
};

export default AlertComponent;
